
let main = {
    initVideoPlayer() {
        TCPlayer('videoPlayer', {
            fileID: '387702301482677532',
            appID: '1259605108',
            autoplay: false,
        })
    },
    initForm() {
        function goto(href) {
            window.open(href + location.search)
        }
        
        var yuyueFirstObj = {
            '': '2022中高考大礼包',
            '?jtppzq': '2022中高考大礼包（百品）',
            '?hd': 'web中高考大礼包（活动）',
            '?tg': 'web中高考大礼包（原生）',
        }
        var query = window.location.search
        
        new Reservation('#form1', {
            siteId: 3, // 站点ID
            contentName: yuyueFirstObj[query], // 预约名称
        })
    },
    init(){
        this.initVideoPlayer()
        this.initForm()
    }
}
main.init()
